<template>
  <div class="stripe-payment-request-button-wrapper" v-if="enabled">
    <div class="form-group">
      <label> or Pay with Apple Pay </label>
      <div ref="paymentRequestButtonEl">
        <!-- A Stripe Element will be inserted here. -->
      </div>
    </div>
  </div>
</template>

<script>
import store from 'src/store'
import stripeLib from 'lib/stripe'
import paymentProfileService from 'api/paymentProfile'

const stripeElements = stripeLib.client.elements()

export default {
  name: 'stripe-payment-request-button',
  props: {
    total: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      enabled: true,
      stripePaymentRequestButton: null,
      paymentRequest: null,
      mobilePaymentOptions: null,
      currentNonce: null,
    }
  },
  methods: {},
  mounted() {
    const venue = store.state.venue.current || {}

    const options = {
      total: {
        label: 'Demo total', //TODO:
        amount: Math.round(this.total), //TODO: wtf??
      },
      country: (venue.address && venue.address.country ? venue.address.country : 'US').toUpperCase(),
      currency: (venue.currencyCode || '').toLowerCase(),
      requestPayerName: true,
      requestPayerEmail: true,
      requestPayerPhone: true,
    }

    const paymentRequest = stripeLib.getPaymentRequest(options)

    this.stripePaymentRequestButton = stripeElements.create('paymentRequestButton', {
      paymentRequest,
    })

    paymentRequest
      .canMakePayment()
      .then((result) => {
        if (!result) {
          this.enabled = false
        }

        this.mobilePaymentOptions = result

        this.stripePaymentRequestButton.mount(this.$refs.paymentRequestButtonEl)
      })
      .catch(() => {
        this.enabled = false
      })

    paymentRequest.on('token', (ev) => {
      this.currentNonce = ev.token.id

      return paymentProfileService
        .create({
          providerToken: this.currentNonce,
          providerType: 'STRIPE',
        })
        .then((paymentProfile) => {
          ev.complete('success')

          this.$emit('paymentProfileCreated', paymentProfile)
        })
    })
  },
  destroyed() {
    this.stripePaymentRequestButton.destroy()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/StripePaymentRequestButton.vue